import { JSX } from 'solid-js';

type SpaceElementProps = {
    size?: number;
    children?: JSX.Element;
    id?: string;
    ref?: HTMLDivElement;
    class?: string;
};

export const VerticalSpace = (props: SpaceElementProps) => (
    <div style={{ height: `${props.size ?? 1}rem` }} id={props.id} ref={props.ref} class={props.class}>{props.children}</div>
);

export const VerticalPixelSpace = (props: SpaceElementProps) => (
    <div style={{ height: `${props.size ?? 11}px` }} id={props.id} ref={props.ref} class={props.class}>{props.children}</div>
);

export const HorizontalSpace = (props: SpaceElementProps) => (
    <div style={{ width: `${props.size ?? 1}rem` }} id={props.id} ref={props.ref} class={props.class}>{props.children}</div>
);
